import React from 'react';

interface ListItem {
  label: string;
  value?: string | React.ReactNode;
  icon?: React.ReactNode;
  subItems?: string[] | React.ReactNode[];
  subBulletIcon?: React.ReactNode;
  className?: string;
}

type FormattedListProps = {
  items: ListItem[];
  className?: string;
};

const FormattedList = ({ items, className = '' }: FormattedListProps) => {
  return (
    <div className={`space-y-3 ${className} overflow-x-auto`}>
      {items.map((item, index) => (
        <div
          key={index}
          className="space-y-2"
        >
          <div className="flex items-center gap-1">
            <span className="mr-2 text-sm text-gray-700">
              {item.icon ? item.icon : '•'}
            </span>
            <span className="flex flex-col md:flex-row md:items-center md:gap-1">
              <span className="whitespace-nowrap text-gray-700">
                {item.label}
              </span>
              <span className="whitespace-normal break-words text-gray-900">
                {item.value ? item.value : ''}
              </span>
            </span>
          </div>
          {item.subItems && item.subItems.length > 0 && (
            <div className="ml-6 space-y-1">
              {item.subItems.map((subItem, subIndex) => (
                <div
                  key={subIndex}
                  className="flex items-baseline"
                >
                  <span className="mr-2  text-gray-400">
                    {item.subBulletIcon ? item.subBulletIcon : '-'}
                  </span>
                  <span className="text-sm text-gray-600 md:text-base ">
                    {subItem}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FormattedList;
